<mat-expansion-panel (click)="goTo(item.code || item.groupCode)" hideToggle="true" class="product mat-typography mat-elevation-z0"
  [ngClass.xs]="{ selected: hasSelection(item) }" [ngClass.gt-xs]="{ desktop: true, selected: hasSelection(item) }"
  [expanded]="expandAll">
  <!-- TODO: add RouterLink -->
  <mat-expansion-panel-header collapsedHeight="60px" expandedHeight="60px">
    <mat-panel-title>
      {{item.name || item.groupName}}
    </mat-panel-title>
    <mat-panel-description>
      {{item.code || item.groupCode}}
    </mat-panel-description>
  </mat-expansion-panel-header>

</mat-expansion-panel>